module.exports = __webpack_public_path__ + "img/diy-YpYyVsXn.fbed7b66.svg";